import React from 'react'
import { AutorenewRounded, CloudOffRounded, HourglassEmptyRounded, MobileOffRounded, PersonOffRounded, VideocamOffRounded } from '@mui/icons-material'
import { COVER_REASON_COLOR } from './visionState'

export const COVER_REASON_ICON = {
  STARTING: AutorenewRounded,
  PHONE: MobileOffRounded,
  NO_CAMERA: VideocamOffRounded,
  SERVICE_UNAVAILABLE: CloudOffRounded,
  NOBODY: PersonOffRounded,
  // C16.10 (S339, Capa.dc.html): «All of MIC» with no slot or released, waiting for a camera.
  WAITING: HourglassEmptyRounded
}

// Story 213 C11.8: the round icon of a cover reason, in its colour. A 423 before Sun said why is drawn as STARTING.
const CoverReasonIcon = ({ reason, size = 64 }) => {
  const known = COVER_REASON_ICON[reason] ? reason : 'STARTING'
  const Icon = COVER_REASON_ICON[known]
  const colour = COVER_REASON_COLOR[known]
  return (
    <span
      aria-hidden='true'
      data-reason={known}
      style={{
        width: size,
        height: size,
        borderRadius: 999,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: colour.background,
        color: colour.foreground,
        flexShrink: 0
      }}
    >
      <Icon sx={{ fontSize: Math.round(size * 0.47) }} />
    </span>
  )
}

export default CoverReasonIcon
